/* GENERATED by scripts/gen-data.mjs — film scene "f-production" (from s1.js + s2.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { FilmScene } from '../../types';

export const F_PRODUCTION: FilmScene = {
  "w": 640,
  "h": 300,
  "items": [
    {
      "k": "box",
      "id": "rq",
      "x": 14,
      "y": 132,
      "w": 104,
      "h": 56,
      "lKey": "films:f-production.items.rq.l"
    },
    {
      "k": "wire",
      "id": "w1",
      "from": "rq",
      "to": "an"
    },
    {
      "k": "box",
      "id": "an",
      "x": 142,
      "y": 132,
      "w": 120,
      "h": 56,
      "lKey": "films:f-production.items.an.l"
    },
    {
      "k": "wire",
      "id": "w2",
      "from": "an",
      "to": "rt"
    },
    {
      "k": "box",
      "id": "rt",
      "x": 288,
      "y": 132,
      "w": 124,
      "h": 56,
      "lKey": "films:f-production.items.rt.l",
      "sKey": "films:f-production.items.rt.s"
    },
    {
      "k": "wire",
      "id": "w3",
      "from": "rt",
      "to": "lo"
    },
    {
      "k": "box",
      "id": "lo",
      "x": 440,
      "y": 52,
      "w": 150,
      "h": 56,
      "lKey": "films:f-production.items.lo.l",
      "sKey": "films:f-production.items.lo.s"
    },
    {
      "k": "wire",
      "id": "w4",
      "from": "rt",
      "to": "re"
    },
    {
      "k": "box",
      "id": "re",
      "x": 440,
      "y": 212,
      "w": 150,
      "h": 56,
      "lKey": "films:f-production.items.re.l",
      "sKey": "films:f-production.items.re.s"
    },
    {
      "k": "wire",
      "id": "w5",
      "from": "rt",
      "to": "au",
      "dash": true
    },
    {
      "k": "chip",
      "id": "au",
      "x": 288,
      "y": 228,
      "w": 124,
      "h": 44,
      "lKey": "films:f-production.items.au.l"
    }
  ],
  "steps": [
    {
      "on": [
        "rq",
        "an",
        "w1"
      ],
      "hot": [
        "an",
        "w1"
      ],
      "capKey": "films:f-production.steps.0.cap"
    },
    {
      "on": [
        "rq",
        "an",
        "w1",
        "rt",
        "w2"
      ],
      "hot": [
        "rt",
        "w2"
      ],
      "capKey": "films:f-production.steps.1.cap"
    },
    {
      "on": [
        "rq",
        "an",
        "w1",
        "rt",
        "w2",
        "lo",
        "w3"
      ],
      "hot": [
        "lo",
        "w3"
      ],
      "capKey": "films:f-production.steps.2.cap"
    },
    {
      "on": [
        "rq",
        "an",
        "w1",
        "rt",
        "w2",
        "re",
        "w4"
      ],
      "hot": [
        "re",
        "w4"
      ],
      "capKey": "films:f-production.steps.3.cap"
    },
    {
      "on": [
        "rq",
        "an",
        "w1",
        "rt",
        "w2",
        "lo",
        "re",
        "w3",
        "w4",
        "au",
        "w5"
      ],
      "hot": [
        "au",
        "w5"
      ],
      "capKey": "films:f-production.steps.4.cap"
    }
  ]
};
